import type { Address } from "@porchpass/ui";
import { DomainAddressType } from "@porchpass/api-client";
import { fieldErrorsAfterSubmitRecord } from "src/forms/fieldErrorsAfterSubmit";

export type DlaAddressFormData = {
  street1?: string;
  street2?: string;
  city?: string;
  county?: string;
  state?: string;
  zip_code?: string;
};

const UI_TO_DLA_FIELD: Partial<
  Record<keyof Address, keyof DlaAddressFormData>
> = {
  street: "street1",
  unit: "street2",
  city: "city",
  county: "county",
  state: "state",
  zipCode: "zip_code",
};

export function toUiAddress(
  dto: DlaAddressFormData,
  addressType: DomainAddressType = DomainAddressType.AddressCurrent,
): Address {
  return {
    street: dto.street1 ?? "",
    unit: dto.street2 ?? "",
    city: dto.city ?? "",
    county: dto.county ?? "",
    state: dto.state ?? "",
    zipCode: dto.zip_code ?? "",
    type: addressType,
    isMailingAddress: addressType === DomainAddressType.AddressMailing,
  };
}

export function fromUiAddressPatch(
  patch: Partial<Address>,
): Partial<DlaAddressFormData> {
  const mapped: Partial<DlaAddressFormData> = {};

  for (const [uiKey, value] of Object.entries(patch)) {
    const dlaKey = UI_TO_DLA_FIELD[uiKey as keyof Address];
    if (dlaKey && value !== undefined) {
      mapped[dlaKey] = value as string;
    }
  }

  return mapped;
}

export function addressErrorsAfterSubmit<
  T extends {
    street1?: { message?: string };
    street2?: { message?: string };
    city?: { message?: string };
    county?: { message?: string };
    state?: { message?: string };
    zip_code?: { message?: string };
  },
>(formErrors: T, hasAttemptedFormSubmission: boolean): Record<string, string> {
  return fieldErrorsAfterSubmitRecord(
    {
      street: formErrors.street1?.message,
      unit: formErrors.street2?.message,
      city: formErrors.city?.message,
      county: formErrors.county?.message,
      state: formErrors.state?.message,
      zipCode: formErrors.zip_code?.message,
    },
    hasAttemptedFormSubmission,
  );
}
